export const SPECS = {
  UseCashierConfirmPaymentFn: 'specs.stores.UseCashierConfirmPaymentFn',
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl',
  ExpressCheckoutFixShippingWhenTaxIsIncluded: 'specs.stores.ExpressCheckoutFixShippingWhenTaxIsIncluded'
};
//# sourceMappingURL=SPECS.js.map